import { DecorationSet } from '@atlaskit/editor-prosemirror/view';
import { selectionPreviewPluginKey } from './selection-preview-plugin-key';
import { SafePlugin } from '../local-safe-plugin';
import { createInlineDecoration } from '../decoration/actions';
import { getPluginState } from '../decoration/decoration-plugin-factory';
export const createSelectionPreviewPlugin = () => {
  return new SafePlugin({
    key: selectionPreviewPluginKey,
    state: {
      init: (_, state) => ({
        selectionPreview: false
      }),
      apply: (tr, _pluginState, _oldEditorState) => {
        if (tr.getMeta('showSelectionPreview')) {
          return {
            selectionPreview: true
          };
        }
        if (tr.getMeta('hideSelectionPreview')) {
          return {
            selectionPreview: false
          };
        }
        return _pluginState;
      }
    },
    props: {
      decorations: editorState => {
        const pluginState = selectionPreviewPluginKey.getState(editorState);
        if (pluginState.selectionPreview) {
          const {
            modalDecorationSet
          } = getPluginState(editorState);
          const modalDecorations = modalDecorationSet.find(0, editorState.doc.content.size);
          const existingHighlightDecoration = modalDecorations.filter(x => {
            var _x$spec;
            return (x === null || x === void 0 ? void 0 : (_x$spec = x.spec) === null || _x$spec === void 0 ? void 0 : _x$spec.key) === 'inlineDecoration';
          })[0];
          if (!existingHighlightDecoration) {
            const highlightDecoration = createInlineDecoration(0, editorState.doc.content.size);
            return DecorationSet.create(editorState.doc, [highlightDecoration]);
          }
        }
        return DecorationSet.empty;
      }
    }
  });
};